import React from 'react';

import { DecisionsState } from './decisionsContextReducer';

type ContextValue = {
  decisions: DecisionsState;
  updateDecision: (serviceId: string, status: boolean) => void;
};

export const DecisionsContext = React.createContext<ContextValue>({} as ContextValue);
